import styled from '@emotion/styled'
import type { FC } from 'react'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'

import TitleWithCards from './components/TitleWithCards'

import data from './data'
import SingleCard from './components/SingleCard'
import TitleWithFAQs from './components/TitleWithFAQs'
import Sidebar from './components/Sidebar'
const values = data
  .filter((e) => e.slug)
  .map((e) => ({
    value: String(e.slug),
    text: e.title,
  }))

const Information: FC = () => {
  return (
    <StyledSectionBase variant="sidebar" sidebarSize="small" sticky={true}>
      <Section.Sidebar as="aside">
        <Section.Sticky>
          <Sidebar id="sidebar" data={values} />
        </Section.Sticky>
      </Section.Sidebar>
      <Section.Contents>
        {data.map((props, key) => {
          switch (props.type) {
            case `SingleCard`:
              return <SingleCard {...props} key={key} />
            case `TitleWithCards`:
              return <TitleWithCards {...props} key={key} />
            case `TitleWithFAQs`:
              return <TitleWithFAQs {...props} key={key} />
            default:
              return false
          }
        })}
      </Section.Contents>
    </StyledSectionBase>
  )
}

const StyledSectionBase = styled(SectionBase)`
  margin-bottom: 40px;

  ${({ theme }) => theme.breakpoints.up(`md`)} {
    margin-bottom: 80px;
  }
`

export default Information
